import "./styles.scss";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useWebmaster } from "context/admin/webmaster";
import useResponsive from "libs/helpers/useResponsive";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import { WebsiteInfoModal } from "page_components/shared/tasks/modals";
import TasksTable from "./TasksTable";
import TasksTiles from "./TasksTiles";
import {
  StatusExplanation,
  PriorityExplanation,
} from "page_components/shared/tasks/explanations";

const actions = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const mainClass = "webmasters-admin-details";

const WebmasterDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { max } = useResponsive();
  const { data, init_loading } = useWebmaster();

  const [websiteInfoId, setWebsiteInfoId] = useState(null);
  const [explanation, setExplanation] = useState(null);
  const [webmaster, setWebmaster] = useState(null);

  useEffect(() => {
    const name = data
      ? `${data?.webmaster?.first_name} ${data?.webmaster?.last_name}`
      : null;

    if (name) setWebmaster(name);
  }, [data]);

  return (
    <>
      <DashboardContentLayout
        backMobile={() => navigate(`/webmasters`)}
        header={{
          label: webmaster,
          description: max.sm
            ? t("Webmasters")
            : {
                value: t("Webmasters"),
                onClick: () => navigate(`/webmasters`),
              },
          async: true,
        }}
        loading={init_loading}
        actions={actions}
      >
        <div className={mainClass}>
          {!max.lg ? (
            <TasksTable
              setWebsiteInfoId={setWebsiteInfoId}
              setExplanation={setExplanation}
            />
          ) : (
            <TasksTiles
              setWebsiteInfoId={setWebsiteInfoId}
              setExplanation={setExplanation}
            />
          )}
        </div>
      </DashboardContentLayout>

      <StatusExplanation
        isOpen={explanation === "status"}
        onClose={() => setExplanation(null)}
      />
      <PriorityExplanation
        isOpen={explanation === "priority"}
        onClose={() => setExplanation(null)}
      />
      <WebsiteInfoModal
        id={websiteInfoId}
        isOpen={!!websiteInfoId}
        onClose={() => setWebsiteInfoId(null)}
      />
    </>
  );
};

export default WebmasterDetails;
